export default function AppSection() {
  return (
    <section id="app" className="py-14 md:py-20 bg-background-50">
      <div className="w-full px-4 md:px-6 max-w-[1280px] mx-auto">
        <div className="flex flex-col lg:flex-row items-center gap-10 bg-background-100 border border-background-200 rounded-3xl p-8 md:p-12 overflow-hidden relative">
          <div className="absolute top-0 right-0 w-64 h-64 bg-primary-100/30 rounded-full blur-3xl -translate-y-1/2 translate-x-1/4"></div>
          <div className="absolute bottom-0 left-0 w-48 h-48 bg-accent-100/30 rounded-full blur-3xl translate-y-1/2 -translate-x-1/4"></div>

          <div className="flex-shrink-0 relative z-10">
            <div className="w-48 h-80 md:w-56 md:h-[420px] rounded-2xl overflow-hidden border-4 border-background-50 shadow-md">
              <img
                src="https://readdy.ai/api/search-image?query=Modern%20smartphone%20mockup%20displaying%20a%20clean%20video%20streaming%20app%20interface%20with%20drama%20posters%20and%20play%20buttons%20in%20warm%20coral%20and%20golden%20tones%2C%20minimalist%20UI%20design%2C%20soft%20gradient%20background%2C%20polished%20app%20store%20style%20presentation&width=560&height=840&seq=app-mockup-001&orientation=portrait"
                alt="努努影院手机端"
                className="w-full h-full object-cover"
                onError={(e) => {
                  const target = e.currentTarget;
                  target.style.display = 'none';
                  target.parentElement!.style.display = 'none';
                }}
              />
            </div>
          </div>

          <div className="flex-1 relative z-10 text-center lg:text-left">
            <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950 mb-3">
              APP下载
            </h2>
            <p className="text-sm md:text-base text-foreground-600 leading-relaxed mb-6 max-w-[480px] mx-auto lg:mx-0">
              努努影院移动端全面适配，手机浏览器打开即用，无需下载安装。支持<strong className="text-foreground-800">画中画播放、倍速切换、历史续看</strong>等功能，让你在地铁上、午休时、睡前被窝里都能随时随地流畅追剧。
            </p>
            <div className="flex flex-wrap items-center justify-center lg:justify-start gap-3 mb-6">
              <span className="inline-flex items-center gap-2 px-5 py-2.5 bg-foreground-950 text-background-50 rounded-full text-sm font-medium whitespace-nowrap cursor-pointer">
                <i className="ri-android-line text-lg"></i>
                Android版
              </span>
              <span className="inline-flex items-center gap-2 px-5 py-2.5 bg-foreground-950 text-background-50 rounded-full text-sm font-medium whitespace-nowrap cursor-pointer">
                <i className="ri-apple-line text-lg"></i>
                iOS版
              </span>
            </div>
            <p className="text-xs text-foreground-400">
              或直接在手机浏览器中访问 nunumovie.com，自动适配移动端界面
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}